class CartDrawer {
    constructor() {
        this.drawer = document.getElementById('cart-drawer');
        this.itemsContainer = document.getElementById('cart-drawer-items');
        this.totalPriceElement = document.querySelector('[data-cart-total]');
        this.checkoutButton = document.querySelector('.cart-drawer__checkout');
        this.footer = document.getElementById('cart-drawer-footer');
        this.termsCheckbox = document.getElementById('cart-terms');

        this.bindEvents();
    }

    bindEvents() {
        // Open drawer triggers
        document.querySelectorAll('a[href="/cart"], .header__cart').forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.open();
            });
        });

        // Close drawer triggers
        this.drawer.querySelectorAll('[data-action="close-cart"]').forEach(trigger => {
            trigger.addEventListener('click', () => this.close());
        });

        // Terms checkbox
        if (this.termsCheckbox && this.checkoutButton) {
            this.checkoutButton.addEventListener('click', (e) => {
                if (!this.termsCheckbox.checked) {
                    e.preventDefault();
                    alert('Будь ласка, погодьтеся з умовами оферти'); // You might want to localize this
                    this.termsCheckbox.parentElement.style.color = 'red';
                }
            });

            this.termsCheckbox.addEventListener('change', () => {
                this.termsCheckbox.parentElement.style.color = '';
            });
        }

        // Delegated events for items
        this.itemsContainer.addEventListener('click', (e) => {
            const target = e.target;

            if (target.closest('.cart-drawer__item-remove')) {
                const key = target.closest('.cart-drawer__item-remove').dataset.key;
                this.updateItem(key, 0);
            }

            if (target.closest('.cart-drawer__qty-btn')) {
                const btn = target.closest('.cart-drawer__qty-btn');
                const key = btn.dataset.key;
                const currentQty = parseInt(btn.dataset.qty);
                const action = btn.dataset.action;

                const newQty = action === 'plus' ? currentQty + 1 : currentQty - 1;
                this.updateItem(key, newQty);
            }
        });
    }

    open() {
        this.drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        this.fetchCart();
    }

    close() {
        this.drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    async fetchCart() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            this.render(cart);
        } catch (error) {
            console.error('Error fetching cart:', error);
        }
    }

    async updateItem(key, quantity) {
        try {
            // Show loading state if needed
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: key,
                    quantity: quantity
                })
            });

            const cart = await response.json();
            this.render(cart);
            this.updateCartCount(cart.item_count);

        } catch (error) {
            console.error('Error updating cart:', error);
        }
    }

    updateCartCount(count) {
        const badges = document.querySelectorAll('.header__cart span');
        badges.forEach(badge => badge.textContent = count);

        // If count is 0, we might want to hide the badge if the design requires it, 
        // but the header.liquid logic currently just renders it if > 0. 
        // We can manipulate the DOM to hide/show.
        if (count === 0) {
            badges.forEach(badge => badge.style.display = 'none');
        } else {
            badges.forEach(badge => {
                badge.style.display = '';
                badge.textContent = count;
            });
        }
    }

    formatMoney(cents) {
        // Basic formatting, can be improved to match shopify format
        return (cents / 100).toFixed(2).replace(/\.00$/, '') + ' грн';
    }

    render(cart) {
        this.totalPriceElement.textContent = this.formatMoney(cart.total_price);

        if (cart.items.length === 0) {
            this.itemsContainer.innerHTML = '<div class="cart-drawer__empty-state"><p>У кошику порожньо :(</p></div>'; // "Cart is empty"
            if (this.footer) this.footer.classList.add('hidden');
            return;
        }

        if (this.footer) this.footer.classList.remove('hidden');

        this.itemsContainer.innerHTML = cart.items.map(item => `
      <div class="cart-drawer__item">
        <img src="${item.featured_image.url}" alt="${item.title}" class="cart-drawer__item-image">
        
        <div class="cart-drawer__item-details">
          <div class="cart-drawer__item-header">
            <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
          </div>
          
          ${item.variant_title && item.variant_title !== 'Default Title' ? `
             <div class="cart-drawer__item-variant">
               ${item.options_with_values.map(opt => `<div><strong>${opt.name}:</strong> ${opt.value}</div>`).join('')}
             </div>
          ` : ''}

          <div class="cart-drawer__item-price">
             ${this.formatMoney(item.original_line_price)}
          </div>

          <div class="cart-drawer__item-quantity">
            <button class="cart-drawer__qty-btn" data-key="${item.key}" data-qty="${item.quantity}" data-action="minus" aria-label="Decrease quantity">&minus;</button>
            <input type="number" class="cart-drawer__qty-input" value="${item.quantity}" readonly>
            <button class="cart-drawer__qty-btn" data-key="${item.key}" data-qty="${item.quantity}" data-action="plus" aria-label="Increase quantity">&plus;</button>
          </div>
        </div>
        
         <button class="cart-drawer__item-remove" data-key="${item.key}" aria-label="Remove item">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
               <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
         </button>
      </div>
    `).join('');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.cartDrawer = new CartDrawer();
});
